import axiosInstance from './AxiosInstance';
import config from '../config';

const { apiAppendPath } = config;
const BASE = apiAppendPath.pharmacyNoteConfigsAppendPath || '/pharmacy-note-configs';

export const getAll = () => axiosInstance.get(BASE);

export const getOne = (id) => axiosInstance.get(`${BASE}/${id}`);

export const getByPharmacyId = (pharmacyId) =>
    axiosInstance.get(BASE, { params: { pharmacyId } });

export const create = (data) => axiosInstance.post(BASE, data);

export const update = (id, data) => axiosInstance.put(`${BASE}/${id}`, data);

export const remove = (id) => axiosInstance.delete(`${BASE}/${id}`);
